import component from '@/mixins/component'
import { brevo } from '@/services'
import RAF from '@/js/utils/raf'

const CITATION_SPEED = 0.8

export default {
  name: 'layout_footer',
  mixins: [component],
  data () {
    return {
      ready: false,
      images: {
        aacc: `${process.env.BASE_URL}images/aacc.png`,
        frenchtech: `${process.env.BASE_URL}images/french_tech.png`
      },
      emailErrorMessage: '',
      emailSuccessMessage: '',
      lang: window.lang
    }
  },
  created () {
    this.$nextTick(() => {
      // let regex = '(?:\/fr)'
      // this.$route.path.match(regex) ? this.lang = 'fr' : this.lang = 'en'
      this.getMenus().then(() => {
        this.ready = true

        this.marqueeOffset = 0
        this.marqueeWidth = 0

        this.$nextTick(() => {
          this.initMarquee()
        })

        RAF.suscribe('footer', this.update.bind(this))
      })
    })
  },
  methods: {
    getMenus: async function () {
      return Promise.all([
        this.$store.getters.get('menu', `footer${window.lang !== 'en' ? '_' + window.lang : ''}`, true),
        this.$store.getters.get('menu', `social${window.lang !== 'en' ? '_' + window.lang : ''}`, true),
        this.$store.getters.get('menu', `legals${window.lang !== 'en' ? '_' + window.lang : ''}`, true)
      ]).then(([footer, social, legals]) => {
        this.footer = footer.items
        this.social = social.items
        this.legals = legals.items
      })
    },
    initMarquee () {
      this.marqueeWidth = this.$refs['footer-citation-titles'][0].offsetWidth
      if (this.marqueeWidth < 100) {
        setTimeout(() => {
          this.initMarquee()
        }, 1000)
      }
    },
    update () {
      this.$refs['footer-citation'].style.transform = `translate3d(${this.marqueeOffset}px, 0, 0)`
      this.marqueeOffset -= CITATION_SPEED
      this.marqueeOffset = this.marqueeOffset % this.marqueeWidth
    },
    subscribe () {
      if (!this.$refs['newsletter-optin'].checked) {
        this.emailErrorMessage = 'You need to consent'
        return
      }

      brevo.add_user(this.$refs.email.value).then(response => {
        if (response.success) {
          this.emailErrorMessage = ''
          this.emailSuccessMessage = this._('newsletter_success')
          this.$refs.email.value = ''
        } else {
          this.emailSuccessMessage = ''
          this.emailErrorMessage = response.error
        }
      })
    }
  }
}
